import colorPalette from '../color-palette';

const { primary } = colorPalette;

export default {
  MuiTab: {
    root: {
      color: primary.main,
    },
    textColorInherit: {
      color: primary.main,
      opacity: 1,
    },
    wrapper: {
      height: '100%',
      display: 'block',
      paddingTop: '2px',
    },
  },
};
